<template>
  <v-container fluid>
    <v-row>
      <v-subheader>Serviços Adicionais</v-subheader>
      <v-card width="100%">
        <base-header-information
          :title="headerTitle"
          :description="headerDescription"
          color="indigo lighten-3"
        >
        </base-header-information>

        <router-view />
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Additional',
  data() {
    return {
      headerTitle: 'Serviços Adicionais',
      headerDescription: `Está precisando de um serviço que não está incluso em seu pacote de
        contabilidade? Aqui você pode solicitar, selecionar e gerenciar os prazos e
        status de todas as atividades extras que pediu para nossa equipe.`,
    }
  },
}
</script>
<style scoped></style>
